import React from "react";

const RefundPolicy = () => {
  return (
    <div className="refund-policy-area space">
      <div className="container">
        <h4 className="mb-4">Refund Policy</h4>
        <p>
          At Gowrisankar Agencies, we aim to provide quality service and products. If you're not satisfied with your purchase, you may request a refund under the following conditions.
        </p>

        <h6>1. Eligibility for Refunds</h6>
        <p>
          Refunds are applicable for defective or incorrect items delivered. To be eligible, requests must be made within 7 days of delivery.
        </p>

        <h6>2. Process</h6>
        <p>
          To initiate a refund, contact us at <a href="mailto:rajesh.katakam@gmail.com">rajesh.katakam@gmail.com</a> with your order details and reason. If approved, refunds will be processed within 3–5 business days.
        </p>

        <h6>3. Non-Refundable Items</h6>
        <p>
          Certain auto parts that have been used, damaged by the user, or returned without original packaging may not be eligible.
        </p>

        <h6>4. Contact</h6>
        <p>
          For refund inquiries, call us at <a href="tel:09248022760">092480 22760</a>.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
